import React from 'react';

const PaymentMethodFormContext = React.createContext();

export default PaymentMethodFormContext;
